/**
 * 《兼容VNode环境》
 * hasOwnProperty - 指示对象自身属性中是否具有指定的属性
 * node 继承 componentOptions
 * */
const hasOwnProperty = Object.prototype.hasOwnProperty

function hasOwn(obj, key) {
  return hasOwnProperty.call(obj, key)
}

export function isVNode(node) {
  return node !== null && typeof node === 'object' && hasOwn(node, 'componentOptions')
}
